// ============================================
// 敵撃破時の処理
// ============================================

import { CONFIG } from '../../config/game-config';
import { ENEMY_CONFIG } from '../../config/enemy-config';
import {
    getScore, setScore,
    getCombo, setCombo,
    getMaxCombo, setMaxCombo,
    getEnemiesDefeated, setEnemiesDefeated,
    getWaveEnemiesDefeated, setWaveEnemiesDefeated,
    incrementDefeatedByType,
    setEnemyBullets,
    setBossDefeatPause
} from '../../store/index';
import { getDiffConfig } from '../../utils/helpers';
import { spawnItem } from '../items/item';
import { checkWaveProgress } from '../../engine/loop/game-loop';
import { createExplosion, createBossDefeatEffect } from '../particles/particles';
import { getP5 } from '../../core/p5-instance';
import type { Enemy } from '../../types/game-types';

interface EnemyDefeatOptions {
    skipExplosion?: boolean;
    lowDropRate?: boolean;
}

/**
 * handleEnemyDefeat() - 敵撃破時の処理
 */
export function handleEnemyDefeat(enemy: Enemy, options: EnemyDefeatOptions = {}): void {
    const p = getP5();
    const diffCfg = getDiffConfig();

    // スコア計算（コンボボーナス付き）
    const baseScore = enemy.score || 100;
    let score = getScore();
    let combo = getCombo();
    score += baseScore * (1 + combo * 0.1);
    setScore(score);

    combo++;
    setCombo(combo);

    const maxCombo = getMaxCombo();
    if (combo > maxCombo) {
        setMaxCombo(combo);
    }

    const enemiesDefeated = getEnemiesDefeated();
    setEnemiesDefeated(enemiesDefeated + 1);

    const waveEnemiesDefeated = getWaveEnemiesDefeated();
    setWaveEnemiesDefeated(waveEnemiesDefeated + 1);

    // 敵タイプ別撃破数を記録
    incrementDefeatedByType(enemy.type);

    // ウェーブ進行チェック
    checkWaveProgress();

    // 爆発エフェクト
    if (!options.skipExplosion) {
        if (enemy.isBoss) {
            createBossDefeatEffect(enemy);
        } else {
            createExplosion(enemy.x, enemy.y, enemy.color);
        }
    }

    // ボス撃破時の特殊処理
    if (enemy.isBoss) {
        setBossDefeatPause(ENEMY_CONFIG.boss.defeatPauseDuration);
        setEnemyBullets([]);
    }

    // アイテムドロップ判定
    let dropChance: number;
    if (enemy.isBoss) {
        dropChance = 1.0;  // ボスは確定ドロップ
    } else if (options.lowDropRate) {
        dropChance = CONFIG.itemSpawnChance * 0.5 * diffCfg.itemDropMult;  // ボム時は低確率
    } else if (enemy.dropBonus) {
        dropChance = enemy.dropBonus * diffCfg.itemDropMult;  // 装甲敵はボーナス
    } else {
        dropChance = CONFIG.itemSpawnChance * diffCfg.itemDropMult;
    }

    if (p.random() < dropChance) {
        spawnItem(enemy.x, enemy.y);
        // ボスは複数アイテムドロップ
        if (enemy.isBoss) {
            spawnItem(enemy.x - 20, enemy.y);
            spawnItem(enemy.x + 20, enemy.y);
        }
    }
}
